var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgilysysIgFly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1209.9 436.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #0299d6;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #7fbc42;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #231f20;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M518.8,353.9h-29.9v-216.8h29.9v216.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M731.7,145.9l-4.9,23.8c-18.6-7.5-39.4-12-59.6-12-53.7,0-86.6,32.9-86.6,90.5s29.6,86.3,87.2,86.3,29-2.3,39.1-5.2v-70.6h27.3v87.2c-16.3,6.8-44.6,12-70,12-71.3,0-113.6-44.9-113.6-109.7s43.6-114.9,116.2-114.9,47.2,4.2,64.8,12.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M838.4,353.9v-216.8h122.1v24.4h-92.1v74.2h88.2v24.4h-88.2v93.7h-29.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1022.3,313.5c0,12.4,4.6,19.5,16.6,19.5s9.8-.7,14.6-2l1.3,21.8c-6.8,2.3-14.6,3.6-23.8,3.6-27.3,0-38.1-18.2-38.1-41.7V124.1h29.3v189.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1092.6,420.9l23.1-65.4-57.3-157.9h30.3l41,127.9,40.4-127.9h30.3l-79.1,223.3h-28.6Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M377.7,178.1c46.4,0,84.1-37.6,84.1-84.1S424.2,10,377.7,10s-84.1,37.6-84.1,84.1,37.6,84.1,84.1,84.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M263.9,123c10.5,13.7,16.3,32.4,16.3,55.7v118h-35.9v-24.5c-11.4,14.3-35.9,28.6-65.3,28.6s-55.9-21.2-55.9-54.3,27.4-53.9,69.8-56.7c17.6-1.2,34.7-1.6,50.6-1.6v-8.6c0-33.1-13.5-53.1-45.7-53.1s-36.3,5.3-51.8,13.9l-8.6-26.9c20.4-12.2,41.6-16.7,66.9-16.7s12.7.6,18.5,1.8c-17.9-7.2-37.4-11.2-57.9-11.2-85.4,0-154.7,69.3-154.7,154.7s69.3,154.7,154.7,154.7,154.7-69.3,154.7-154.7-21.7-90.5-55.7-118.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.6,246.4c0,18.4,11.4,27.3,31,27.3s40.4-10.6,53.9-25.3v-36.3c-16.3.8-30.2,2-44.1,3.7-22.9,2.4-40.8,9.4-40.8,30.6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgilysysIgFly);
export default __webpack_public_path__ + "static/media/AgilysysIGFly.dd4123e9ca472aa35e3629aa5f9001bf.svg";
export { ForwardRef as ReactComponent };